// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getSectionRequest: ['data'],
  getSectionSuccess: ['data'],
  getSectionFailure: ['err'],

  postSectionRequest: ['data'],
  postSectionSuccess: ['data'],
  postSectionFailure: ['err'],

  putSectionRequest: ['data'],
  putSectionSuccess: ['data'],
  putSectionFailure: ['err'],

  deleteSectionRequest: ['data'],
  deleteSectionSuccess: ['data'],
  deleteSectionFailure: ['err'],

  // getSectionRequest: ['data'],
  // getSectionSuccess: ['data'],
  // getSectionFailure: ['err'],

  postSubSectionRequest: ['data'],
  postSubSectionSuccess: ['data'],
  postSubSectionFailure: ['err'],

  putSubSectionRequest: ['data'],
  putSubSectionSuccess: ['data'],
  putSubSectionFailure: ['err'],

  deleteSubSectionRequest: ['data'],
  deleteSubSectionSuccess: ['data'],
  deleteSubSectionFailure: ['err']
})

export const SectionTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: [],
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) =>
  state.merge({ fetching: true, err: null })

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null,
    success: null
  })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_SECTION_SUCCESS]: success,
  [Types.GET_SECTION_REQUEST]: request,
  [Types.GET_SECTION_FAILURE]: failure,

  [Types.POST_SECTION_SUCCESS]: manipulateSuccess,
  [Types.POST_SECTION_REQUEST]: manipulateRequest,
  [Types.POST_SECTION_FAILURE]: manipulateFailure,

  [Types.PUT_SECTION_SUCCESS]: manipulateSuccess,
  [Types.PUT_SECTION_REQUEST]: manipulateRequest,
  [Types.PUT_SECTION_FAILURE]: manipulateFailure,

  [Types.DELETE_SECTION_SUCCESS]: manipulateSuccess,
  [Types.DELETE_SECTION_REQUEST]: manipulateRequest,
  [Types.DELETE_SECTION_FAILURE]: manipulateFailure,

  [Types.POST_SUB_SECTION_SUCCESS]: manipulateSuccess,
  [Types.POST_SUB_SECTION_REQUEST]: manipulateRequest,
  [Types.POST_SUB_SECTION_FAILURE]: manipulateFailure,

  [Types.PUT_SUB_SECTION_SUCCESS]: manipulateSuccess,
  [Types.PUT_SUB_SECTION_REQUEST]: manipulateRequest,
  [Types.PUT_SUB_SECTION_FAILURE]: manipulateFailure,

  [Types.DELETE_SUB_SECTION_SUCCESS]: manipulateSuccess,
  [Types.DELETE_SUB_SECTION_REQUEST]: manipulateRequest,
  [Types.DELETE_SUB_SECTION_FAILURE]: manipulateFailure,
})



// WEBPACK FOOTER //
// ./src/Redux/SectionRedux.js